import request from '@/plugins/axios'

// 工作台信息 
export const apiWorkbenchIndex = () => request.get('/workbench/index')

// 商品列表 
export const apiWorkbenchTopAmount = (params: any) => request.get('workbench/topAmount', params)

// 用户列表 
export const apiWorkbenchTopUser = (params: any) => request.get('/workbench/topUser', params)

// 检测更新
export const apiCheckRefresh = (params?: any) => request.get('/workbench/checkVersion', params)

// 检测正版
export const apiCheckLegal = (params?: any) => request.get('/workbench/checkLegal', params)

/**
 * 获取用户选择列表的API接口函数
 * @param params - 请求参数对象，包含查询条件等
 * @returns 返回一个Promise对象，包含用户选择列表的数据
 */
export const apiSelectUser = (params?: any) => request.get('/shop.shop/listsForSelection', {params})
